module.exports = __webpack_public_path__ + "img/3查看结构.0f2f1246.gif";